import {price} from '@/lib/format'

export const MIN_PRICE = 400000
export const MAX_PRICE = 5000000
export const FORMATED_MIN_PRICE = price(MIN_PRICE)
